import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

const AdminLoginPage = () => {
    const { isAdminAuthenticated, adminLogin } = useAdminAuth();
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (isAdminAuthenticated) {
            navigate("/funcard-admin-dashboard/panel", { replace: true });
        }
    }, [isAdminAuthenticated]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const success = adminLogin(username, password);
        if (success) {
            navigate("/funcard-admin-dashboard/panel", { replace: true });
        } else {
            setError("Invalid credentials.");
            setPassword("");
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#f4f6fb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "24px",
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
                    padding: "48px 40px",
                    width: "100%",
                    maxWidth: 420,
                }}
            >
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                    <div
                        style={{
                            width: 56,
                            height: 56,
                            borderRadius: "50%",
                            background: "#2575fc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 16px",
                        }}
                    >
                        <i className="ph-fill ph-shield-check" style={{ fontSize: 26, color: "#fff" }} />
                    </div>
                    <h4 style={{ fontWeight: 700, marginBottom: 4, color: "#1a1a1a" }}>Admin Access</h4>
                    <p style={{ color: "#94a3b8", fontSize: 14, margin: 0 }}>Enter your credentials to continue</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 20 }}>
                        <label style={{ display: "block", fontWeight: 600, fontSize: 13, color: "#374151", marginBottom: 8 }}>
                            Username
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Username"
                            autoComplete="off"
                            style={{
                                width: "100%",
                                padding: "12px 16px",
                                border: "1px solid #e5e7eb",
                                borderRadius: 8,
                                fontSize: 14,
                                outline: "none",
                                boxSizing: "border-box",
                                color: "#1a1a1a",
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: 24 }}>
                        <label style={{ display: "block", fontWeight: 600, fontSize: 13, color: "#374151", marginBottom: 8 }}>
                            Password
                        </label>
                        <div style={{ position: "relative" }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                autoComplete="off"
                                style={{
                                    width: "100%",
                                    padding: "12px 44px 12px 16px",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: 8,
                                    fontSize: 14,
                                    outline: "none",
                                    boxSizing: "border-box",
                                    color: "#1a1a1a",
                                }}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: "absolute",
                                    right: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "#94a3b8",
                                    fontSize: 18,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <i className={`ph ${showPassword ? "ph-eye-slash" : "ph-eye"}`} />
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div
                            style={{
                                background: "#fef2f2",
                                border: "1px solid #fecaca",
                                color: "#ef4444",
                                borderRadius: 8,
                                padding: "10px 14px",
                                fontSize: 13,
                                marginBottom: 20,
                            }}
                        >
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        style={{
                            width: "100%",
                            padding: "13px",
                            background: "#2575fc",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            fontWeight: 600,
                            fontSize: 15,
                            cursor: "pointer",
                        }}
                    >
                        Sign In
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLoginPage;
